module.exports = __webpack_public_path__ + "media/images/emblems/Untervaz_wappen-4ec87eef83848f417fa8b136b543585e.svg";